import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { checkHOD, checkHOU } from '../../permission-utils/settings';
import { request } from '../../services/utilities';
import { rosterAPI } from '../../services/constants';

const DoctorMenu = () => {
	const [isSupervisor, setIsSuperVisor] = useState(false);
	const [isHOS, setIsHOS] = useState(false);
	const profile = useSelector(state => state.user.profile);
	const dept = profile?.details?.department?.slug;
	const role = profile?.role?.slug;

	useEffect(() => {
		const fetchData = async () => {
			const isHOD = await checkHOD();
			const isHOU = await checkHOU();

			if (isHOD || isHOU) {
				setIsSuperVisor(true);
			}
		};

		fetchData();
	}, []);

	useEffect(() => {
		const checkHOS = async () => {
			try {
				const staffId = profile?.details?.id;
				const deptId = profile?.details?.department?.id;
				if (!staffId || !deptId) return;
				const period = moment().format('YYYY-MM');
				const today = moment().date();
				const hour = moment().hour();
				const currentShift = hour >= 8 && hour < 17 ? 'Morning' : 'Night';
				const uri = `${rosterAPI}/rosters?period=${period}&department_id=${deptId}&staff_id=${staffId}`;
				const rs = await request(uri, 'GET', true);
				if (rs?.length) {
					const schedule = rs[0]?.schedule || [];
					const todayEntry = schedule.find(s => s.schedule_date === today);
					if (todayEntry?.is_hos && todayEntry?.duty === currentShift) {
						setIsHOS(true);
					}
				}
			} catch (e) {
				// silently fail
			}
		};
		checkHOS();
	}, [profile]);

	const isDoctor = role === 'doctor';
	const isItAdmin = role === 'it-admin';

	return (
		<>
			{isDoctor && (
				<li className="sub-header">
					<span>CONSULTATIONS</span>
				</li>
			)}
			{isSupervisor && (
				<li>
					<Link to="/doctor/overview">
						<div className="icon-w">
							<div className="icon-feather-home" />
						</div>
						<span>Overview</span>
					</Link>
				</li>
			)}
			<li>
				<Link to="/doctor">
					<div className="icon-w">
						<div className="icon-feather-home" />
					</div>
					<span>Dashboard</span>
				</Link>
			</li>
			<li>
				<Link to="/doctor/appointment-history">
					<div className="icon-w">
						<div className="os-icon os-icon-calendar-time" />
					</div>
					<span>Appointment History</span>
				</Link>
			</li>
			<li>
				<Link to="/doctor/online-consultations">
					<div className="icon-w">
						<div className="os-icon os-icon-ui-90" />
					</div>
					<span>Online Consultations</span>
				</Link>
			</li>
			<li>
				<Link to="/doctor/bookings/pending">
					<div className="icon-w">
						<div className="icon-feather-home" />
					</div>
					<span>Bookings</span>
				</Link>
			</li>
			<li>
				<Link to="/front-desk/patients">
					<div className="icon-w">
						<div className="os-icon os-icon-cv-2" />
					</div>
					<span>Patients</span>
				</Link>
			</li>

			{isDoctor && (
				<li className="sub-header">
					<span>IN-PATIENT</span>
				</li>
			)}
			<li>
				<Link to="/nurse/in-patients/admitted">
					<div className="icon-w">
						<div className="icon-feather-folder-plus" />
					</div>
					<span>In-Patient</span>
				</Link>
			</li>
			<li>
				<Link to="/nurse/in-patients/orders">
					<div className="icon-w">
						<div className="icon-feather-clipboard" />
					</div>
					<span>In-Patient Requests</span>
				</Link>
			</li>
			<li>
				<Link to="/nurse/in-patients/ward-requests">
					<div className="icon-w">
						<div className="icon-feather-alert-circle" />
					</div>
					<span>Ward Requests</span>
				</Link>
			</li>

			{isDoctor && (
				<li className="sub-header">
					<span>SPECIALTIES</span>
				</li>
			)}
			<li>
				<Link to="/nicu">
					<div className="icon-w">
						<div className="os-icon os-icon-documents-03" />
					</div>
					<span>NICU</span>
				</Link>
			</li>
			<li>
				<Link to="/ivf">
					<div className="icon-w">
						<div className="os-icon os-icon-documents-07" />
					</div>
					<span>IVF</span>
				</Link>
			</li>
			<li>
				<Link to="/antenatal/enrolled">
					<div className="icon-w">
						<div className="os-icon os-icon-documents-13" />
					</div>
					<span>Antenatal</span>
				</Link>
			</li>
			<li>
				<Link to="/labour-mgt">
					<div className="icon-w">
						<div className="os-icon os-icon-documents-13" />
					</div>
					<span>Labour Management</span>
				</Link>
			</li>

			{isDoctor && (
				<li className="sub-header">
					<span>OTHER</span>
				</li>
			)}
			<li>
				<Link to="/doctor/excuse-duty">
					<div className="icon-w">
						<div className="os-icon os-icon-documents-13" />
					</div>
					<span>Excuse duty</span>
				</Link>
			</li>
			<li>
				<Link to="/doctor/excuse-duty">
					<div className="icon-w">
						<div className="os-icon os-icon-documents-13" />
					</div>
					<span>Staff Excuse duty</span>
				</Link>
			</li>
			<li>
				<Link to="/doctor/medical-reports">
					<div className="icon-w">
						<div className="os-icon os-icon-documents-03" />
					</div>
					<span>Medical Reports</span>
				</Link>
			</li>
			{/* {(isItAdmin || (isDoctor && (isSupervisor || isHOS))) && (
				<li>
					<Link to="/team/room-assignment">
						<div className="icon-w">
							<div className="os-icon os-icon-home" />
						</div>
						<span>Room Assignment</span>
					</Link>
				</li>
			)} */}
			{isSupervisor && (
				<li>
					<Link to="/report/doctor">
						<div className="icon-w">
							<div className="os-icon os-icon-layers" />
						</div>
						<span>Reports</span>
					</Link>
				</li>
			)}
			{dept === 'radiology' && role === 'doctor' && (
				<>
					<li className="sub-header">
						<span>RADIOLOGY</span>
					</li>
					<li>
						<Link to="/radiology">
							<div className="icon-w">
								<div className="os-icon os-icon-layers" />
							</div>
							<span>Dashboard</span>
						</Link>
					</li>
				</>
			)}
		</>
	);
};

export default DoctorMenu;
